import axios from 'axios';
import { PatientHistory, PatientHistoryModel } from '../models/patient-history';

export const getPatientHistories = async (): Promise<PatientHistory[]> => {
    const response = await axios.get('/api/patient-history');
    return response.data && response.data.map(n => ({   // TODO: camel case 
        ...n,
        icd10Code: n.icd10Code || n.icD10Code
    }));
};

export const getPatientHistoriesAsync = async (): Promise<PatientHistoryModel[]> => {
    const response = await axios.get('/api/patient-history');
    return response.data && response.data.map(n => ({   // TODO: camel case 
        ...n,
        icd10Code: n.icd10Code || n.icD10Code
    }));
};
